import { Team } from "msd-capacity-planning-model";
import env from "../app/Environment";
import fetchService from "../utils/FetchService";

export interface TeamService {
  fetch(dateFilter?: string): Promise<Team[]>;
  delete(id: string, dateFilter?: string): Promise<Team[]>;
  persist(item: Team, dateFilter?: string): Promise<Team[]>;
}

class HTTPTeamService implements TeamService {
  constructor(private endpoint: string) {}

  async fetch(dateFilter?: string): Promise<Team[]> {
    const query = dateFilter
      ? `?dateFilter=${encodeURIComponent(dateFilter)}`
      : "";
    return fetchService
      .fetch(`${this.endpoint}/teams${query}`)
      .then((r) => r.json())
      .catch((): any[] => []);
  }

  async delete(id: string, dateFilter?: string): Promise<Team[]> {
    return fetchService
      .fetch(`${this.endpoint}/teams/${id}`, {
        method: "DELETE",
      })
      .then(() => this.fetch(dateFilter));
  }

  async persist(item: Team, dateFilter?: string): Promise<Team[]> {
    return fetchService
      .fetch(`${this.endpoint}/teams`, {
        method: "POST",
        body: JSON.stringify(item),
      })
      .then(() => this.fetch(dateFilter));
  }
}

const regionService: TeamService = new HTTPTeamService(env.endpoint);

export default regionService;
